export function serializeLayerGeometry(layer) {
  if (!layer || typeof layer.toGeoJSON !== "function") return null;

  const geojson = layer.toGeoJSON();
  if (geojson.type === "FeatureCollection") {
    return featureCollectionGeometry(geojson);
  }
  if (geojson.type === "Feature") {
    return geojson.geometry;
  }

  return geojson.geometry || geojson;
}

function featureCollectionGeometry(featureCollection) {
  const polygonCoordinates = [];

  featureCollection.features.forEach((feature) => {
    const geometry = feature.geometry;
    if (!geometry) return;

    if (geometry.type === "Polygon") {
      polygonCoordinates.push(geometry.coordinates);
    } else if (geometry.type === "MultiPolygon") {
      polygonCoordinates.push(...geometry.coordinates);
    }
  });

  if (polygonCoordinates.length === 0) return null;
  if (polygonCoordinates.length === 1) {
    return {
      type: "Polygon",
      coordinates: polygonCoordinates[0],
    };
  }

  return {
    type: "MultiPolygon",
    coordinates: polygonCoordinates,
  };
}
